<template>
    <v-container>
    <v-card v-bind:style="styleObject">
      <div class="card-header" style="background-color: #004d40 !important;">
        <h2 class="font-weight-regular">Form Registrasi Customer</h2>
      </div>
      <v-container style="margin-bottom:1rem;"> 
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            :style="{ width:'800px' }"
        >
            <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Name"
                required
            ></v-text-field>

            <v-text-field
                v-model="username"
                :rules="usernameRules"
                label="Username"
                required
            ></v-text-field>

            <v-select
                v-model="role_id"
                :items="roles"
                item-value="id"
                item-text="name"
                :rules="[v => !!v || 'role is required']"
                label="Tipe User"
                required
            ></v-select>

            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
            ></v-text-field>

            <v-text-field
                v-model="telp"
                label="Telp"
                required
            ></v-text-field>

            <v-text-field
                v-model="password"
                type="password"
                :rules="passwordRules"
                label="Password"
                required
            ></v-text-field>

            <v-text-field
                v-model="conf_password"
                type="password"
                :rules="conf_passwordRules"
                label="Confirmation"
                required
            ></v-text-field>

            <v-btn
                :disabled="!valid"
                class="mt-4 float-right btn"
                @click="validate"
                style="background-color: #004d40 !important; color:white;"
            >
                Daftar
            </v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-container>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    data(){
        return{
            valid: true,
            telp: null,
            role_id: null,
            styleObject: {
                margin: "1rem auto",
                borderRadius: '8px'
            },
            name: null,
            nameRules: [
                v => !!v || 'name is required',
            ],
            username: null,
            usernameRules: [
                v => !!v || 'username is required',
            ],
            email: null,
            emailRules: [
                v => !!v || 'email is required',
                v => /.+@.+\..+/.test(v) || 'email must be valid',
            ],
            password: null,
            passwordRules:[
                v => !!v || 'password is required',
            ],
            conf_password: null,
            conf_passwordRules:[
                v => !!v || 'confirmation password is required',
            ],
            roles:[]
        }
    },
    computed:{
        ...mapGetters({
            roleUnverified: "user/roleUnverified",
        }),
    },
    methods:{
        ...mapActions({
            registrasi: "user/registrasi"
        }),
        async initialize() {
            const getRoles = await this.roleUnverified
            for(let role of getRoles.data.attributes){
                this.roles.push({
                    name: role.name == 'unverified' ? 'Personal' : 'Company',
                    id: role.id
                })
            }
        },
        async validate(){
            let payload = {
                name: this.name,
                username: this.username,
                role_id: this.role_id,
                email: this.email,
                telp: this.telp,
                password: this.password
            }
            if(this.password != this.conf_password){
                alert('Password tidak sama dengan konfirmasi password')
            }else{
                let response = await this.registrasi(payload)
                if(response.data.success){
                    this.name = null,
                    this.username = null,
                    this.role_id = null,
                    this.email = null
                    this.telp = null
                    this.password = null
                    this.valid = false
                    this.conf_password = null
                    this.$refs.form.reset()
                    this.$notify({
                        group: "custom-notification",
                        type: "success",
                        title: "Success!",
                        text: "Berhasil Registrasi"
                    });
                }
            }
        }
    },
    async created(){
        await this.initialize();
    }
}
</script>

<style scoped>
.card-header {
    text-align:center;
    padding:1rem;
  }
  .card-header h2{
    margin:0;
    color:#fff;
  }
  .btn {
    background-color: #004d40 !important;
    color:#fff;
    padding:0;
    text-transform: capitalize !important;
    /* font-size:1.3rem */
  }
</style>